export default __webpack_public_path__ + "static/media/nav_detail_img_13.20405250.jpg";